import { useChatContext } from '../context/ChatContext';
import { RiChatNewLine } from 'react-icons/ri';
import { FiDownload } from 'react-icons/fi';
import { useEffect, useState } from 'react';

const ChatHeader = ({ onNewChat, onDownloadClick }) => {
  const { messages, isDownloading } = useChatContext();
  const [isNative, setisNative] = useState(false);
  
  // Get URL query parameters
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const queryObject = Object.fromEntries(urlParams.entries());
    setisNative(queryObject.isNative === 'true');
    console.log('URL Query Parameters:', queryObject);
  }, []);

  const clearClientCaches = async () => {
    // 1) Clear Service Worker Cache Storage (if your app uses it)
    if ('caches' in window) {
      const keys = await caches.keys();
      await Promise.all(keys.map((k) => caches.delete(k)));
    }

    // 2) Clear any chat/session state you persist locally
    // Prefer removing only your app's keys instead of clearing everything:
    // localStorage.removeItem('vb_chat_messages');
    // localStorage.removeItem('vb_chat_session');
    // sessionStorage.removeItem('vb_chat_draft');

    // If you’re not sure what keys you use and you’re OK wiping all:
    localStorage.clear();
    sessionStorage.clear();

    // 3) If you have a service worker, ask it to update
    if ('serviceWorker' in navigator) {
      const regs = await navigator.serviceWorker.getRegistrations();
      await Promise.all(regs.map((r) => r.update()));
    }
  };

  const handleNewChatClick = async () => {
    await clearClientCaches();

    // reset chat UI/state first
    onNewChat?.();

    // Optional: force reload so the browser refetches assets/data
    // (This helps if stale JS/CSS/data is being served from SW/cache)
    window.location.reload();
  };

  return (
    <div className='chat-header'>
      <button onClick={handleNewChatClick} className='refresh-button'>
        <RiChatNewLine size={14} /> <span>New Chat</span>
      </button>

      <span className='chat-title'>
        BeachBot
        <br />
        <span className='chat-beta'>(beta)</span>
      </span>

      <button
        className={`${isNative ? 'download-button-hidden' : 'header-download-button'}`}
        onClick={onDownloadClick}
        disabled={messages.length <= 1 || isDownloading}
      >
        <FiDownload size={14} />{' '}
        <span>{isDownloading ? '⏳ Downloading...' : 'Download'}</span>
      </button>
    </div>
  );
};

export default ChatHeader;
